import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden z-10 animate-hero">
      <div className="relative z-10 max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop w-full">
        <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
          <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary mb-6">
            <span className="material-symbols-outlined text-[18px]">verified_user</span>
            <span className="font-label-sm text-label-sm uppercase tracking-widest">Institutional Grade Algorithms</span>
          </div>
          <h1 className="font-display-lg text-display-lg md:text-[64px] md:leading-[1.1] mb-6">
            Why Pay MQL5 Prices? <br/>
            <span className="text-gradient-gold">Get Premium EAs for 80-90% Less.</span>
          </h1>
          <p className="font-body-lg text-body-lg text-on-surface-variant mb-10 max-w-2xl mx-auto">
            Save up to 80–90% on premium MT4/MT5 Expert Advisors compared to leading marketplace prices—without compromising on quality, performance, or reliability.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center w-full">
            <Link to="/marketplace" className="bg-primary-container text-on-primary font-bold px-8 py-4 rounded-lg flex items-center justify-center space-x-2 hover:scale-[1.02] active:scale-95 transition-all btn-shimmer">
              <span className="font-label-md text-label-md">Browse Marketplace</span>
              <span className="material-symbols-outlined">arrow_forward</span>
            </Link>
            <button className="border-2 border-white/10 text-silver-text font-bold px-8 py-4 rounded-lg hover:border-primary/50 transition-all flex items-center justify-center">
              Request Any EA
            </button>
          </div>
          <div className="mt-12 flex items-center justify-center space-x-6">
            <div className="flex -space-x-3">
              <div className="w-10 h-10 rounded-full border-2 border-surface bg-surface-container-high flex items-center justify-center text-xs font-bold text-primary">VN</div>
              <div className="w-10 h-10 rounded-full border-2 border-surface bg-surface-container-high flex items-center justify-center text-xs font-bold text-secondary">AR</div>
              <div className="w-10 h-10 rounded-full border-2 border-surface bg-surface-container-high flex items-center justify-center text-xs font-bold text-error">SP</div>
              <div className="w-10 h-10 rounded-full border-2 border-surface bg-surface-container-high flex items-center justify-center text-xs font-bold text-surface-tint">RM</div>
            </div>
            <div className="text-left">
              <div className="font-bold text-silver-text">395+ Traders</div>
              <div className="text-label-sm text-on-surface-variant">Trust Algo Forex EA for their trading bots</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
